import { initAll } from 'govuk-frontend';

import 'hmpo-components/all.js';
import '@hmpo-dcs/web-shared/all.js';

initAll();
